import $ from '../utils/jquery';

const $select = $( '#senate-phone-select' );
const $results = $( '#senate-phone-results' );

const bind = () => {
	$select.on( 'change', e => {
		const value = $select.val();
		const results = window.senatePhoneList[ value ];

		// Clear existing HTML
		$results.html( '' );

		// Build the list HTML
		if ( results && Array.isArray( results ) && results.length > 0 ) {
			let listHtml = '<ul class="call-list">';
			results.forEach( result => {
				if ( result.name && result.phone ) {
					// listHtml += `<li class="call-list-item">${ result.name }: <a href="tel:${ result.phone }">${ result.phone }</a></li>`;
					listHtml += `<li class="call-list-item">${ result.name }: ${ result.phone }</li>`;
				}
			} );
			listHtml += '</ul>';
			$results.html( listHtml );
		}
	} );
};

export default () => {
	if ( ! $select.length ) {
		return;
	}

	bind();
};
